type UseProjectModelError = {
  invalidProjectName: boolean;
};

const useProjectModelError: UseProjectModelError = {
  invalidProjectName: false,
};

export type { UseProjectModelError };

export { useProjectModelError };
